var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option-wrapper"},[(_vm.model.length)?_c('runtime-template-compiler',{attrs:{"template":_vm.model}}):(_vm.node)?_c('wrap-node',{attrs:{"tag":"div","value":_vm.node}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }